module.exports = __webpack_public_path__ + "img/gas1.e3a731ca.png";